import { FormattedMessage } from 'react-intl';

import SvgBankIcon from '@shieldpay/bumblebee/icons/BankIcon';
import { Barclays, UnitedKingdom } from '@shieldpay/bumblebee/images';

import { Heading } from '@shieldpay/bumblebee/heading';
import { Column, Row } from '@shieldpay/bumblebee/layout';
import PillMarkdown from '@shieldpay/bumblebee/markdown/pill.md';
import { Pill } from '@shieldpay/bumblebee/pill';
import { Text } from '@shieldpay/bumblebee/text';
import { TextList } from '@shieldpay/bumblebee/text-list';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { Design } from '~/components/design/design';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.pill.title',
});

export const PillComponentPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.pill.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview alignContent={{ x: 'left' }}>
        <Row spacing="base">
          <Pill>Default Pill</Pill>
          <Pill variant="action">Action Pill</Pill>
          <Pill variant="alert">Alert Pill</Pill>
          <Pill variant="success">Success Pill</Pill>
          <Pill variant="warning">Warning Pill</Pill>
          <Pill variant="info">Info Pill</Pill>
          <Pill variant="noValue">No Value Pill</Pill>
        </Row>

        <Row spacing="base">
          <Pill>Super Long text example this one is</Pill>

          <Pill>
            <SvgBankIcon size="xs" /> Icon
          </Pill>
          <Pill>
            <UnitedKingdom alt="uk" size="xs" /> Flag
          </Pill>
          <Pill>
            <Barclays size="xs" /> Bank
          </Pill>
        </Row>
      </ComponentPreview>

      <Design>
        <Design.Section heading="Anatomy">
          <Text paragraph>
            The text is positioned to be optically centered in the pill. The
            pill is constructed with a Caption text style within 150 height
            works out at 34px tall. The size of the pill will depend of the
            content. Once it reaches 150px, it is truncated with an ellipsis.
          </Text>
        </Design.Section>
        <Design.Section heading="Usage">
          <Text paragraph>
            Pills should be used in place of text when a little more visual
            context is required - such as for statuses. Use adjectives for the
            names of the pills. Do not use verbs, verbs might suggest that the
            pill is clickable and can be be used to perform actions.
          </Text>
        </Design.Section>
        <Design.Section heading="Colour usage">
          <Column>
            <Text paragraph>
              The colours of the pill will vary depending on the status they
              represent. Using established color patterns will help users
              identify their status.
            </Text>
            <Text paragraph>
              Use green for status to represent completed processes such as:
              funded, paid, completed, passed.
            </Text>
            <TextList>
              <TextList.Item>Background: Shieldpay/Secondary-200</TextList.Item>
              <TextList.Item>Outline: Shieldpay/Secondary-500</TextList.Item>
            </TextList>

            <Text paragraph>
              Use grey to represent initiated processes such as created.
            </Text>
            <TextList>
              <TextList.Item>Background: Global/neutral-150</TextList.Item>
              <TextList.Item>Outline: Global/neutral-500</TextList.Item>
            </TextList>

            <Text paragraph>
              Use red to represent critical status such as cancelled.
            </Text>
            <TextList>
              <TextList.Item>Background: Global/alert-200</TextList.Item>
              <TextList.Item>Outline: Global/alert-500</TextList.Item>
            </TextList>

            <Text paragraph>
              Use purple to represent processes waiting for an action such as:
              pending, in progress, partially approved.
            </Text>
            <TextList>
              <TextList.Item>Background: Shieldpay/Primary-200</TextList.Item>
              <TextList.Item>Outline: Shieldpay/Primary-500</TextList.Item>
            </TextList>
          </Column>
        </Design.Section>

        <Design.Section heading="Accessibility">
          <Text paragraph>
            Accessibility Use the appropriate ARIA attributes for screen readers
            where applicable.
          </Text>
        </Design.Section>
      </Design>

      <MdxFormatter md={PillMarkdown} />
    </>
  );
};

export default PillComponentPage;
